import { useState } from "react";
import { useStore } from "store";
import { useNavigate } from "react-router-dom";
import { useWindowDimensions } from "resources/BrowserManager";
import {
  Flex,
  Space,
  Card,
  Typography,
  Tag,
  Button,
  theme,
  message,
  Modal,
} from "antd";
const { Title, Text } = Typography;
import ApiManager from "resources/ApiManager/api";
import CONSTANTS from "shared/constants";
import strings from "resources/strings";

import {
  UserOutlined,
  Loading3QuartersOutlined,
  CrownFilled,
  DownloadOutlined,
} from "@ant-design/icons";

import "./style.scss";
const styleWrapperClass = "profile";

import { getFormattedUnixDate } from "shared/utilities";

export const TextLine = ({ label, values, wrap }) => {
  const { isSmallView } = useWindowDimensions();

  return (
    <Flex
      align="flex-start"
      gap={wrap && isSmallView ? 0 : 4}
      wrap={false}
      vertical={wrap && isSmallView}
    >
      {label && values?.some((i) => i) && (
        <Text
          strong
          style={{
            whiteSpace: "nowrap", // label stays in one line
            flexShrink: 0,
          }}
        >
          {label}:
        </Text>
      )}

      <Flex
        wrap="wrap"
        gap={3}
        style={{
          minWidth: 0,
          wordBreak: "normal",
          overflowWrap: "normal", // wrap only by words
        }}
      >
        {values?.map((i, index) => i && <Text key={index}>{i}</Text>)}
      </Flex>
    </Flex>
  );
};

export default function Reports() {
  const { token: theme_token } = theme.useToken();
  const { isSmallView } = useWindowDimensions();
  const navigate = useNavigate();

  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const [isPdfLoading, setIsPdfLoading] = useState(false);

  const active_rfc_obj = ["nuevo-rfc", "onboarding"].includes(activeRfc)
    ? null
    : user.rfcs[activeRfc];

  const BannerFeatureNotAvailable = () => (
    <Space
      style={{
        marginTop: "20px",
        marginBottom: "20px",
        width: "100%",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Space direction="vertical">
        <Title level={3}>
          Disponible en el plan <CrownFilled className="fg-gold" /> Pro ó Básico
        </Title>
        <Title level={5}>
          Para ver y generar reportes, deberás subscribirte al plan{" "}
          <CrownFilled className="fg-gold" /> Pro ó Básico.
        </Title>
        <Button onClick={() => navigate("/plan")}>Ver Planes</Button>
      </Space>
    </Space>
  );

  return (
    <div className={styleWrapperClass}>
      <Title level={1}>Reportes</Title>

      {["pro", "basic"].includes(active_rfc_obj.plan_name) ? (
        <>
          <Title level={4}>
            Administra y descarga los reportes generados de tus CFDIs.
          </Title>
          {false ? (
            <Flex
              style={{ marginTop: "30px", marginBottom: "30px" }}
              vertical
              gap={30}
            >
              Data
            </Flex>
          ) : (
            <Flex vertical align="center" style={{ marginTop: "50px" }}>
              <Text style={{ fontSize: "18px", textAlign: "center" }}>
                No has generado reportes.
              </Text>
            </Flex>
          )}
        </>
      ) : (
        <BannerFeatureNotAvailable />
      )}
    </div>
  );
}
